import { ShortCode } from '@highereducation/wordpress';
import { Label } from '@highereducation/hen-ui';

interface LabelShortcodeProps {
  variant?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'heading'
    | 'subtext';
  size?: 'l1' | 'l2';
  disabled?: string;
  required?: string;
  'html-for'?: string;
  [key: string]: any;
}

export const LabelShortcode: ShortCode<LabelShortcodeProps> = {
  component: ({
    variant = 'default',
    size = 'l1',
    disabled,
    required,
    'html-for': htmlFor,
    children,
  }) => {
    const isDisabled = disabled === 'true' || disabled === '';
    const isRequired = required === 'true' || required === '';

    return (
      <Label
        variant={variant}
        size={size}
        disabled={isDisabled}
        required={isRequired}
        htmlFor={htmlFor}
      >
        {children}
      </Label>
    );
  },
};
